import { render, staticRenderFns } from "./Prelievi.vue?vue&type=template&id=68fa8071&"
import script from "./Prelievi.vue?vue&type=script&lang=js&"
export * from "./Prelievi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports